export const DynamicEarnEvent = {
  DynamicEarnSubscribeClick: 'dynamic_earn_subscribe_click',
  DynamicEarnExploreClick: 'dynamic_earn_explore_click',
  DynamicEarnDepositDepositClick: 'dynamic_earn_deposit_deposit_click',
  DynamicEarnSubscriptionConfirmClick: 'dynamic_earn_subscription_confirm_click',
  DynamicEarnRedeemClick: 'dynamic_earn_redeem_click',
  DynamicEarnRedemptionTypeClick: 'dynamic_earn_redemption_type_click',
  DynamicEarnRedemptionConfirmClick: 'dynamic_earn_redemption_confirm_click',
  DynamicEarnIntroContinueClick: 'dynamic_earn_intro_continue_click',
  DynamicEarnIntroSubscribeClick: 'dynamic_earn_intro_subscribe_click',
  DynamicEarnProductDetailPageView: 'dynamic_earn_product_detail_page_view',
  DynamicEarnLiquidationAlertPopupView: 'dynamic_earn_liquidation_alert_popup_view',
  DynamicEarnLiquidationAlertAdjustClick: 'dynamic_earn_liquidation_alert_adjust_click',
  DynamicEarnProductDetailChipClick: 'dynamic_earn_product_detail_chip_click',
  DynamicEarnCollateralNoticeModalView: 'dynamic_earn_collateral_notice_modal_view',
  DynamicEarnCollateralNoticeConfirmClick: 'dynamic_earn_collateral_notice_confirm_click',
  DynamicEarnProductDetailPageClick: 'dynamic_earn_product_detail_page_click',
  DynamicEarnProviderDetailPageView: 'dynamic_earn_provider_detail_page_view',
};

export interface DynamicEarnEventDataType {
  [DynamicEarnEvent.DynamicEarnSubscribeClick]: {
    product_name: 'Narsil USDT Prime';
    cumulative_earnings: string;
    apr: string;
  };
  [DynamicEarnEvent.DynamicEarnExploreClick]: {
    product_name: 'Narsil USDT Prime';
    apr: string;
  };
  [DynamicEarnEvent.DynamicEarnDepositDepositClick]: {
    product_name: 'Narsil USDT Prime';
  };
  [DynamicEarnEvent.DynamicEarnSubscriptionConfirmClick]: {
    product_name: 'Narsil USDT Prime';
    subscribed_amount: string;
  };
  [DynamicEarnEvent.DynamicEarnRedeemClick]: {
    product_name: 'Narsil USDT Prime';
    cumulative_earnings: string;
    apr: string;
  };
  [DynamicEarnEvent.DynamicEarnRedemptionTypeClick]: {
    product_name: 'Narsil USDT Prime';
    redemption_option: 'Standard' | 'Instant';
  };
  [DynamicEarnEvent.DynamicEarnRedemptionConfirmClick]: {
    product_name: 'Narsil USDT Prime';
    redemption_amount: string;
    available_amount: string;
  };
  [DynamicEarnEvent.DynamicEarnIntroContinueClick]: {
    product_name: 'Narsil USDT Prime';
    total_index: number;
    step_index: number;
  };
  [DynamicEarnEvent.DynamicEarnIntroSubscribeClick]: {
    product_name: 'Narsil USDT Prime';
    apr: string;
  };
  [DynamicEarnEvent.DynamicEarnProductDetailPageView]: {
    product_name: 'Narsil USDT Prime';
  };
  [DynamicEarnEvent.DynamicEarnProductDetailChipClick]: {
    product_name: 'Narsil USDT Prime';
    button_name: string;
  };
  [DynamicEarnEvent.DynamicEarnProductDetailPageClick]: {
    button_type: 'video' | 'earn_while_trading';
  };
}
